export enum HttpMethod {
  DELETE = "DELETE",
  GET = "GET",
  HEAD = "HEAD",
  OPTIONS = "OPTIONS",
  PATCH = "PATCH",
  POST = "POST",
  PUT = "PUT"
}

export enum HttpStatusCode {
  OK = 200,
  BAD_REQUEST = 400
}

export enum BadgeStatuses {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  PENDING = "Pending",
  CANCELLED = "Cancelled",
  CREATED = "Created",
  REJECTED = "Rejected"
}

export enum BadgeStatus {
  NotChecked,
  Correct,
  Incorrect,
  Staff,
  PhotoRequired,
  GoToServiceDesk,
  ScannedInXMinutes
}

export enum ReasonCodes {
  BadgeNotFound = "BadgeNotFound",
  FaultyQrCode = "FaultyQrCode",
  InvalidStatus = "InvalidStatus",
  InvalidVersion = "InvalidVersion",
  BadgeAlreadyPrinted = "BadgeAlreadyPrinted",
  ReprintTooSoon = "ReprintTooSoon",
  IdCheckFailed = "IdCheckFailed",
  BadgeUnpaid = "BadgeUnpaid",
  UnableToDecryptBadge = "UnableToDecryptBadge",
  InvalidEventEdition = "InvalidEventEdition"
}

export enum BadgeSyncStatus {
  SUCCESS = "success",
  DOWNLOADING = "downloading",
  DOWNLOAD_FAILED = "download_failed",
  SYNCING_FAILED = "syncing_failed"
}

export enum ColocatedShowDataSyncStatus {
  IDLE = "idle",
  SYNCING = "syncing",
  FAILED = "failed"
}

export enum LogResult {
  True = "True",
  False = "False"
}

export enum BadgeRegistrationTypes {
  MYSELF = "Myself",
  MYSELF_AND_COLLEAGUES = "MyselfAndColleagues",
  BY_SOMEONE_ELSE = "BySomeoneElse"
}

export enum BadgeCreatedByTypes {
  COORDINATOR = "coordinator"
}

export enum PDF_MAX_LENGTHS {
  LETTER = 250,
  A4 = 240,
  FOUR_X_TEN_INCH = 220
}

export enum STOCK_STATUS {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK"
}

export enum PAPER_SIZE {
  A4 = "A4",
  LETTER = "LETTER",
  FOUR_X_TEN_INCH = "FOUR_X_TEN_INCH",
  W105xH140mm = "W105xH140mm"
}

export enum VALID_ZONE_TYPES {
  MAIN_SHOW_ACCESS = "Main Show Access",
  CONTROLLED_AREA = "Controlled Area",
  SESSIONS = "Session"
}

export enum Locale {
  enGB = "en-GB",
  enUS = "en-US"
}

export enum ShowMode {
  OVERVIEW = "OVERVIEW",
  LOCATIONS = "LOCATIONS"
}

export enum BADGE_EVENTS {
  DOWNLOAD = "DOWNLOAD"
}

export enum Variant {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info"
}

export enum PrintMethods {
  PRINT_DIRECT = "PRINT_DIRECT",
  PRINT_SERVER = "PRINT_SERVER"
}

export enum DeviceType {
  SCANNER = "scanner",
  KIOSK = "kiosk"
}

export enum ChipStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DEACTIVATED = "deactivated",
  CONFIGURED = "configured",
  NEW = "new"
}

export enum HttpErrorStatus {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403
}

export enum FREYA_ORIENTATION {
  NORMAL = "NORMAL",
  ROTATED_180 = "ROTATED_180"
}

export enum OdinAccess {
  PRINTER_SETUP = "printerSetup",
  DEVICE_SETUP = "deviceSetup",
  SHOW_STATISTICS = "showStatistics",
  CREATE_NEW_REGISTRATION = "createNewRegistration",
  DOWNLOAD_SHOW_STATISTICS = "downloadShowStatistics",
  EDIT_REGISTRATION = "editRegistration",
  UPGRADE_BADGE = "upgradeBadge"
}

export enum UserRoles {
  MANAGER = "custSvcsManager",
  FINANCE = "finance",
  CUSTOMER_SERVICES_AGENT = "custSvcsAgent",
  RX_ADMIN = "rxAdmin",
  BU_ADMIN = "buAdmin"
}

export enum ProductRxType {
  REGISTRATION = "Registration"
}

export enum ProductContactType {
  COMPANY = "Company"
}

export enum ProductTypename {
  GROUPED_PRODUCT = "GroupedProduct"
}

export enum SiteLocales {
  EN_GB = "en-GB",
  EN_US = "en-US",
  FR_FR = "fr-FR",
  JA_JP = "ja-JP",
  DE_DE = "de-DE",
  DE_AT = "de-AT",
  PT_BR = "pt-BR",
  ES_MX = "es-MX"
}

export enum REASON_CODE {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E"
}

export enum REGISTRATION_TYPE {
  BLOCKED = "BLOCKED",
  APPROVED = "APPROVED",
  NONE = "NONE"
}

export enum FreyaScanningMode {
  CAMERA = "CAMERA",
  SCANNER = "SCANNER"
}

export enum CURRENCIES {
  AUSTRALIA = "aud",
  UK = "gbp"
}

export enum BadgePaymentStatus {
  PAID = "Paid",
  UNPAID = "Unpaid",
  UNPAID_OVERRIDDEN = "Unpaid Overridden",
  FREE = "Free"
}

export enum StaffUserAccess {
  MANAGER = "CustomerServicesManager",
  AGENT = "CustomerServicesAgent",
  FINANCE = "Finance"
}

export enum PhotoUploadSources {
  FREYA = "Freya",
  ODIN = "Odin"
}

export enum MagentoPaymentMethods {
  BANK_TRANSFER = "banktransfer",
  FREE = "free",
  PAID = "paid"
}

export enum PaymentMethods {
  CARD = "CARD",
  CASH = "CASH",
  CHEQUE = "CHEQUE",
  BANK_TRANSFER = "BANK_TRANSFER",
  FREE = "FREE",
  DEBIT_CARD = "DEBIT",
  INVOICE_CREDIT='INVOICE_CREDIT'
}

export enum ExhibitorType {
  VISITING_COMPANY = "visitingCompany",
  SHARER = "Sharer",
  MSH = "MSH"
}

export enum CountryWithState {
  USA = "USA",
  IND = "IND",
  AUS = "AUS"
}

export enum PrintServerVersion {
  V4 = "V4",
  V7 = "V7"
}

export enum UpgradeErrorType {
  NETWORK = "NETWORK",
  UPGRADE = "UPGRADE",
  ENTITLEMENT = "ENTITLEMENT"
}

export enum UpgradeResponseCode {
  SUCCESS = "Success",
  FAILURE = "Failure"
}

export enum CustomerType {
  tradeVisitor = "tradeVisitor",
  hostedBuyer = "hostedBuyer",
  vipOrBuyersProg = "vipOrBuyersProg",
  speaker = "speaker",
  pressOrMedia = "pressOrMedia",
  conferenceDelegate = "conferenceDelegate",
  exhibitingDelegate = "exhibitingDelegate",
  studentOrLecturer = "studentOrLecturer",
  public = "public",
  contractor = "contractor",
  staff = "staff"
}

export enum BusinessUnit {
  US = "OBU_001",
  JAPAN = "OBU_018",
  FRANCE = "OBU_003",
  AUSTRALIA = "OBU_007",
  UK = "OBU_017",
  INDIA = "OBU_020"
}

export enum PrinterPaperNames {
  W105xH140mm = "Custom.105x140mm"
}

export enum FreyaScannersNames {
  DENSOWAVE = "densoWave",
  TERAPRO = "teraPro",
  SUNMI = "sunmi",
  WASP = "wasp",
  OTHER = "other"
}
